import { render } from "./ToursView.vue?vue&type=template&id=083f42f0&ts=true"
import script from "./ToursView.vue?vue&type=script&lang=ts"
export * from "./ToursView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__